import { CommonModule } from '@angular/common';
import {Component, Input, ChangeDetectionStrategy, Inject, ChangeDetectorRef} from '@angular/core';
import {environment} from "../../../environments/environment";
import {EventBusService} from "../../services/event-bus.service";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../config/hotel-tours-list-page.config";

@Component({
  selector: 'app-hotel-view-count',
  templateUrl: './hotel-view-count.component.html',
  styleUrls: environment.mobile ? ['./hotel-view-count.component.mobile.scss'] : ['./hotel-view-count.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class HotelViewCountComponent {
  messages: any = {};
  hasHotelViewCount = false;
  hotelViewCount = 0;

  @Input() hotelId: number;

  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
    private eventBus: EventBusService,
    private cdRef: ChangeDetectorRef,
  ) {
    this.messages = {
      hotelViewCount: this.hotelToursPageConfig.translates.hotelViewCount
    };
  }

  ngOnInit() {
    this.eventBus.hotelViewCount$.subscribe((data) => {
      if (this.hotelId === data.hotelId) {
        this.hasHotelViewCount = true;
        this.hotelViewCount = data.count;
        this.cdRef.detectChanges();
      }
    });
  }
}
